"use client"

import * as React from "react"
import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"

import { cn } from "@/shared/lib/utils"
import { Button } from "@/shared/ui/button"
import { Calendar } from "@/shared/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/ui/popover"
import { SelectSingleEventHandler } from "react-day-picker"

interface DatePickerProps {
  selected: Date | null
  onSelect: (date: Date | null) => void
  placeholderText?: string
  className?: string
}

export function DatePicker({
  selected,
  onSelect,
  placeholderText = "日付を選択",
  className,
}: DatePickerProps) {
  // onSelect関数をSelectSingleEventHandler型に変換
  const handleSelect: SelectSingleEventHandler = (day) => {
    // dayがundefinedの場合はnullに変換
    onSelect(day ?? null);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-full justify-start text-left font-normal",
            !selected && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {selected ? format(selected, "yyyy年MM月dd日") : placeholderText}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected || undefined}
          onSelect={handleSelect}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
} 